// enterToTab.js
const closeAllDropdowns = function() {
  var openDropdowns = document.querySelectorAll('.el-select-dropdown.is-poppered');
  var openPickers = document.querySelectorAll('.el-picker-panel.is-poppered');
  var openMenus = document.querySelectorAll('.el-menu--dropdown.is-poppered');
  
  openDropdowns.forEach(function(el) {
    el.style.display = 'none';
    el.classList.remove('is-poppered');
  });
  
  openPickers.forEach(function(el) {
    el.style.display = 'none';
    el.classList.remove('is-poppered');
  });
  
  openMenus.forEach(function(el) {
    el.style.display = 'none';
    el.classList.remove('is-poppered');
  });
  
  var selectTriggers = document.querySelectorAll('.el-select');
  selectTriggers.forEach(function(el) {
    el.classList.remove('is-open');
  });
  
  var pickerTriggers = document.querySelectorAll('.el-date-picker, .el-time-picker, .el-date-editor');
  pickerTriggers.forEach(function(el) {
    el.classList.remove('is-picker-opened');
  });
};

const focusNextElement = function(el) {
  var selector = [
    'input:not([tabindex="-1"]):not([disabled]):not([readonly])',
    'select:not([tabindex="-1"]):not([disabled]):not([readonly])',
    'textarea:not([tabindex="-1"]):not([disabled]):not([readonly])',
    'button:not([tabindex="-1"]):not([disabled])',
    '[tabindex]:not([tabindex="-1"]):not([disabled])'
  ].join(',');
  
  var focusableElements = Array.from(el.querySelectorAll(selector)).filter(function(item) {
    return item.offsetParent !== null && 
           !item.closest('.el-collapse-item__header') &&
           !item.classList.contains('el-collapse-item__header');
  });

  var currentActive = document.activeElement;
  var currentIndex = focusableElements.findIndex(function(item) {
    return item === currentActive || item.contains(currentActive);
  });

  if (currentIndex > -1) {
    var nextIndex = currentIndex + 1;
    if (nextIndex < focusableElements.length) {
      focusableElements[nextIndex].focus();
    } else {
      if (focusableElements[0]) {
        focusableElements[0].focus();
      }
    }
  }
};

const bind = function(el, binding) {
  var enabled = binding.value !== undefined ? binding.value : true;
  if (!enabled) return;

  var handleEnter = function(e) {
    if (e.key !== 'Enter') return;

    var isCollapseHeader = e.target.closest('.el-collapse-item__header');
    if (isCollapseHeader) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      focusNextElement(el);
      return;
    }

    var isRadio = e.target.type === 'radio';
    var isRadioGroup = e.target.closest('.el-radio-group');
    var isRadioButton = e.target.classList.contains('el-radio__input');
    
    if (isRadio || isRadioGroup || isRadioButton) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      focusNextElement(el);
      return;
    }

    var isCheckbox = e.target.type === 'checkbox';
    var isCheckboxGroup = e.target.closest('.el-checkbox-group');
    var isCheckboxButton = e.target.classList.contains('el-checkbox__input');
    
    if (isCheckbox || isCheckboxGroup || isCheckboxButton) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      focusNextElement(el);
      return;
    }

    var isButton = e.target.tagName === 'BUTTON';
    var isElButton = e.target.classList.contains('el-button');
    var isButtonGroup = e.target.closest('.el-button-group');
    
    if (isButton || isElButton || isButtonGroup) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      focusNextElement(el);
      return;
    }

    var isSelect = e.target.closest('.el-select');
    var isDatePicker = e.target.closest('.el-date-picker, .el-date-editor');
    var isTimePicker = e.target.closest('.el-time-picker');
    var isTimeSelect = e.target.closest('.el-time-select');
    var isCascader = e.target.closest('.el-cascader');
    
    var hasOpenDropdown = document.querySelector('.el-select-dropdown.is-poppered');
    var hasOpenPicker = document.querySelector('.el-picker-panel.is-poppered');

    if ((isSelect || isDatePicker || isTimePicker || isTimeSelect || isCascader) && (hasOpenDropdown || hasOpenPicker)) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      setTimeout(function() {
        focusNextElement(el);
      }, 100);
      return;
    }

    var isDateInput = e.target.closest('.el-date-picker, .el-date-editor') && e.target.classList.contains('el-input__inner');
    var isTimeInput = e.target.closest('.el-time-picker') && e.target.classList.contains('el-input__inner');
    
    if (isDateInput || isTimeInput) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      focusNextElement(el);
      return;
    }

    var isInput = e.target.tagName === 'INPUT';
    var isTextarea = e.target.tagName === 'TEXTAREA';
    var isSelectInput = e.target.classList.contains('el-input__inner');
    
    if (isInput || isTextarea || isSelectInput) {
      e.preventDefault();
      e.stopPropagation();
      closeAllDropdowns();
      focusNextElement(el);
    }
  };

  el.__handleKeydown__ = handleEnter;
  el.addEventListener('keydown', handleEnter, true);
};

const unbind = function(el) {
  if (el.__handleKeydown__) {
    el.removeEventListener('keydown', el.__handleKeydown__, true);
    el.__handleKeydown__ = null;
  }
};

export default {
  bind: bind,
  unbind: unbind,
};



// WEBPACK FOOTER //
// ./src/directives/enter-next.js